import {$window, $body} from '../../../Constants';
import SwiperSlider from '../../../Elements/SwiperSlider';

/**
 * Teaser Slider
 */
const TeaserSlider = (() => {
  /**
   * Selector
   *
   * @var { Object }
   */
  const Selector = {
    TEASER_SLIDER: '.teaser-slider.swiper-container',
  };

  /**
   * Class Name
   *
   * @var { Object }
   */
  const ClassName = {
    CAN_CENTER: 'can-center'
  };

  /**
   * Teaser Slider
   *
   * @class
   * @augments SwiperSlider
   */
  class TeaserSlider extends SwiperSlider {
    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      super.onReady();

      this.setOptions({
        spaceBetween: !this.$element.hasClass('collapse') ? 30 : 0,
        slidesPerView: 5,
        grabCursor: true,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        /**
         * Update breakpoints to read a data-attribute named after data-(name of the breakpoint)
         * If there is no data attribute, use the default value for slidesPerView
         */
        breakpoints: {
          1600: {
            slidesPerView: parseInt(this.$element.data('1600-slides-per-view')) || 4
          },
          1200: {
            slidesPerView: parseInt(this.$element.data('1200-slides-per-view')) || 3
          },
          1023: {
            slidesPerView: parseInt(this.$element.data('1023-slides-per-view')) || 2
          },
          550: {
            slidesPerView: parseInt(this.$element.data('550-slides-per-view')) || 1
          }
        },
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazy: true
      });

      this._initialize();
      this._bindHandlers();
      this._handleCentering();
    }

    /**
     * Binds the event handlers to the elements
     *
     * @return void
     */
    _bindHandlers() {
      $window.on('resize', () => {
        this._handleCentering();
      });
    }

    /**
     * Handles the centering by adding or removing the css class
     *
     * @return void
     */
    _handleCentering() {
      this.$element.toggleClass(ClassName.CAN_CENTER, this.length < this.slider.params.slidesPerView);
    }
  }

  return TeaserSlider._getElements($body.find(Selector.TEASER_SLIDER), TeaserSlider);
})();

export default TeaserSlider;
